export default __webpack_public_path__ + "static/media/auto-segment.29362ae3.svg";